import React from "react";
import { useNavigate } from "react-router-dom";
import { mdiChevronLeft } from "@mdi/js";
import Icon from "@mdi/react";
import { clsx } from "clsx";

import { ReactComponent as LetterLogo } from "assets/letter-logo.svg";
import { LogoIcon, LogoIconForLight } from "components/SVGIcons";
import { useColorScheme } from "hooks/useColorScheme";
import useDeviceType from "hooks/useDeviceType";
import styles from "./style.module.scss";

interface IProps {
  hideHeader?: boolean;
  goBackPath?: string;
  containerClass?: string;
  className?: string;
  children: React.ReactNode;
  isApplyHaulpay?: boolean;
}

export default function OnboardingLayout({
  hideHeader = false,
  goBackPath,
  containerClass,
  className,
  children,
  isApplyHaulpay = false
}: Readonly<IProps>) {
  const navigate = useNavigate();
  const { isIOS, isAndroid } = useDeviceType();
  const { currentIsDark } = useColorScheme();

  function goBack() {
    goBackPath ? navigate(goBackPath) : navigate(-1);
  }

  return (
    <div className={clsx(styles.onboardingContainer, containerClass)}>
      <div className={clsx(styles.header, isIOS && "!pt-16", isAndroid && "!pt-10")}>
        <>
          {!hideHeader ? (
            <>
              <div className={clsx(styles.logo, isApplyHaulpay ? "pl-2" : "mx-auto")}>
                {currentIsDark ? (
                  <LogoIcon className="size-11" />
                ) : (
                  <LogoIconForLight className="size-11" />
                )}
                <LetterLogo className={styles.textLogo} />
              </div>
              {!isApplyHaulpay ? (
                <span className={styles.subtitle}>Digital Freight Finance & Load Tech</span>
              ) : null}
            </>
          ) : (
            <button onClick={goBack}>
              <Icon path={mdiChevronLeft} className="size-8" />
            </button>
          )}
        </>
      </div>

      <div className={clsx(styles.mainWrapper, className)}>{children}</div>
    </div>
  );
}
